export interface LazyInitializer<T> {
  (): T;
}

export class Lazy<T> {
  private instance: T | null = null;
  private initializer: LazyInitializer<T>;

  constructor(initializer: LazyInitializer<T>) {
    this.initializer = initializer;
  }

  public get value(): T {
    if (this.instance === null) {
      this.instance = this.initializer();
    }

    return this.instance;
  }

  public map<U>(mapFunctor: (value: T) => U) {
    return new Lazy(() => mapFunctor(this.value));
  }
}

export interface AsyncLazyInitializer<T> {
  (): Promise<T>;
}

export class AsyncLazy<T> {
  private instance: Promise<T> | null;
  private initializer: AsyncLazyInitializer<T>;

  constructor(initializer: AsyncLazyInitializer<T>) {
    this.initializer = initializer;
    this.instance = null;
  }

  public get value(): Promise<T> {
    if (!this.instance) {
      this.instance = new Promise<T>((resolve, reject) => {
        this.initializer()
          .then((value) => {
            resolve(value);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
    return this.instance;
  }
}
